<template>
  <div class="article-detail--page">
    <van-nav-bar title="Talk 工控" left-text="返回" left-arrow @click-left="handleBack" :fixed="true" />
    <!-- right-text="分享" -->
    <!-- @click-right="share" -->
    <!-- <div v-if="detail">
      <img src="" alt="">
    </div>-->
    <div class="zhanwei"></div>
    <div class="content" v-if="loading">
      <van-loading class="loading-img" size="24px">加载中...</van-loading>
    </div>
    <div v-else-if="isError" class="content content-empty">
      <img src="/assets/imgs/content-empty@2x.jpg" alt class="empty-img" />
      <div class="empty-msg">啊哦，此文章已被删除</div>
    </div>
    <div v-else-if="isNetWorkError" class="content network-error content-empty">
      <div class="empty-icon">
        <i class="iconfont icon-duanwang"></i>
      </div>
      <div class="empty-msg">信号好像飞到外太空了…请刷新页面</div>
      <div class="text-c mart-15">
        <van-button size="mini" @click="reload">刷新</van-button>
      </div>
    </div>
    <div class="content" v-else>
      <h1 class="title w">{{detail.Title}}</h1>
      <div class="author-block w row-flex">
        <div class="avatar" @click="goPersonal">
          <Avatar class="avatar" :size="26" :src="userInfo.Avatar"></Avatar>
        </div>
        <div class="author-info row-flex-eq" @click="goPersonal">
          <h3 class="author-name">
            <span class="name">{{userInfo.NickName}}</span>
            <svg
              v-if="userInfo.Type == 1"
              class="svg-icon author-icon"
              aria-hidden="true"
            >
              <use xlink:href="#icon-qiye1" />
            </svg>
            <svg
              v-if="userInfo.Type == 14 "
              class="svg-icon author-icon"
              aria-hidden="true"
            >
              <use xlink:href="#icon-zhuanjia" />
            </svg>
            <svg v-if="userInfo.Type == 22" class="svg-icon author-icon" aria-hidden="true">
              <use xlink:href="#icon-hangjia" />
            </svg>
          </h3>
          <div class="text-gray author-msg ellipsis">{{detail.PublishDate | time-parse}}</div>
        </div>
        <div class="follow">
          <followBtn
            v-if="!isMyArticle"
            v-model="userInfo.FollowStatus"
            :FollowedUserId="userInfo.Id"
            @onSuccess="handleFollowSuccess"
          ></followBtn>
        </div>
      </div>
      <div class="video-box w" v-if="detail.Type === 2">
        <video
          v-if="detail.Free"
          :src="detail.VideoUrl"
          controls="controls"
          preload="metadata"
          :poster="detail.CoverImage"
        ></video>
        <video
          v-else
          :src="detail.TrialContent"
          controls="controls"
          preload="metadata"
          :poster="detail.CoverImage"
        ></video>
        <div class="trial-msg text-blue" v-if="!detail.Free">&lt; 此视频为试看片段，需付费观看完整视频 &gt;</div>
      </div>
      <div class="detail-content w">
        <div v-if="detail.Free" v-html="detail.Content" id="articleDetail"></div>
        <div v-else-if="detail.Type == 1" v-html="detail.TrialContent" id="articleDetail"></div>
        <div v-else v-html="detail.Content" id="articleDetail"></div>
        <div class="article-shadow" v-if="!detail.Free">
          <van-icon class="article-shadow-icon1" name="arrow-down" />
          <van-icon class="article-shadow-icon2" name="arrow-down" />
        </div>
      </div>
      <div class="reward-box">
        <div v-if="detail.Free" class="reward-btn text-c">
          <van-button type="primary" @click="showRewardDialog">打赏支持</van-button>
        </div>
        <div v-else>
          <div class="reward-btn text-c">
            <van-button type="primary" @click="showPaidDialog">仅需{{detail.Price}}元即可收获知识满满</van-button>
          </div>
        </div>
        
      </div>
      <div>
        <div
          class="payment-title"
          v-if="PaymentTotal"
        >
          <span>{{PaymentTotal}}人付款</span>
        </div>
        <div class="payment-list">
          <Avatar
            v-for="(payment, index) in PaymentList"
            :key="index"
            class="payment-avatar"
            :size="36"
            :src="payment"
          ></Avatar>
          <span
            v-if="PaymentTotal > 7"
            class="payment-more-icon payment-avatar"
          >
            <van-icon name="weapp-nav" />
          </span>
        </div>
      </div>
      <div class="feature-good mart-15 w" v-if="detail.IsProduct">
        <div class="title">特色商品</div>
        <div class="md-card mart-15">
          <ProductBlock v-for="pItem in detail.FeatureProduct" :key="pItem.Id" :info="pItem"></ProductBlock>
        </div>
      </div>

      <div class="more-info w row-flex">
        <div class="row-flex-eq">
          <span class="text-gray" @click="showComplain = true">我要投诉</span>
          <span class="text-gray">·</span>
          <span class="text-gray">阅读{{detail.ViewQuantity}}</span>
        </div>

        <span class="copyright-icon text-gray" @click="showCopyright = true">© 版权声明</span>
      </div>
      <div class="tag-box w">
        <div class="title">搜索</div>
        <div class="tag-group row-flex-base">
          <div
            class="md-tag"
            v-for="(tag, idx) in detail.Tags"
            :key="idx"
            round
            @click="gotoSearch(tag)"
          >{{tag}}</div>
        </div>
      </div>

      <div class="change-box w">
        <goodBtn
          class="change-btn"
          v-model="detail.IsGood"
          :sourceId="Id"
          :goodCount="detail.GoodQuantity"
          size="big"
          @onSuccess="handleGoodSuccess"
        ></goodBtn>
        <!-- 企业账户才能 被 交换名片 -->
        <changeCardBtn
          class="change-btn"
          v-if="userInfo.Type === 1 && !isMyArticle"
          :FollowStatus="userInfo.FollowStatus"
          :FollowedUserId="userInfo.Id"
          @changeSuccess="handleFollowSuccess"
        ></changeCardBtn>
      </div>
      <div class="w">
        <div class="md-card">
          <div class="author-block author-bottom row-flex">
            <div class="avatar" @click="goPersonal">
              <Avatar class="avatar" :size="26" :src="userInfo.Avatar"></Avatar>
            </div>
            <div class="author-info row-flex-eq" @click="goPersonal">
              <h3 class="author-name">
                <span class="name">{{userInfo.NickName}}</span>
                <svg v-if="userInfo.Type === 1" class="svg-icon author-icon" aria-hidden="true">
                  <use xlink:href="#icon-qiye1" />
                </svg>
                <svg v-if="userInfo.Type === 14" class="svg-icon author-icon" aria-hidden="true">
                  <use xlink:href="#icon-zhuanjia" />
                </svg>
                <svg v-if="userInfo.Type === 22" class="svg-icon author-icon" aria-hidden="true">
                  <use xlink:href="#icon-hangjia" />
                </svg>
              </h3>
              <div class="text-gray author-msg ellipsis">{{userInfo.Introduction || '-' }}</div>
            </div>
            <div class="follow">
              <followBtn
                v-if="!isMyArticle"
                v-model="userInfo.FollowStatus"
                :FollowedUserId="userInfo.Id"
                @onSuccess="handleFollowSuccess"
              ></followBtn>
            </div>
          </div>
        </div>
      </div>

      <div class="related-article w" v-if="relatedList.length">
        <div class="title">相关</div>
        <ArticleBlock v-for="aItem in relatedList" :key="aItem.Id" :info="aItem" reverse />
      </div>
      <div class="line w"></div>
      <div class="comment-box w" id="aritcle-comment">
        <div class="title">评论</div>
        <CommentList
          v-if="!loading"
          :ArticleId="detail.Id"
          :isFav="detail.IsFav"
          :AuthorId="userInfo.Id"
          :ArticleType="detail.Type"
        />
      </div>
    </div>
    <complaintDialog v-model="showComplain" :ArticleId="detail.Id" />
    <copyrightDialog v-model="showCopyright" />
    
    <rewardDialog ref="rewardDialog" @paySuccess='rewardSuccess'></rewardDialog>
    <paidReadDialog
      ref="paidReadDialog"
      @paySuccess="handlePaidReadSuccess"
    ></paidReadDialog>
  </div>
</template>

<script>
import { Cms } from "@/api";
import ProductBlock from "@/components/product/productBlock.vue";
import ArticleBlock from "@/components/article/articleBlock.vue";
import commonMix from "@/mixins/commonMix.js";
import goodBtn from "@/components/article/goodBtn.vue";
import complaintDialog from "@/components/article/complaintDialog.vue";
import copyrightDialog from "@/components/article/copyrightDialog.vue";
import Avatar from "@/components/avatar";
import CommentList from "@/components/comment/commentList.vue";
import followBtn from "@/components/article/followBtn.vue";
import EventBus from "@/services/bus";
import rewardDialog from "@/components/article/rewardDialog.vue";
import paidReadDialog from "@/components/article/paidReadDialog.vue";
import shareServices from "@/services/shareServices";
import payServices from "@/services/payServices";
import { ImagePreview } from "vant";
import changeCardBtn from "@/components/common/changeCardBtn";
export default {
  name: "articleBlock",
  mixins: [commonMix],
  components: {
    ProductBlock,
    ArticleBlock,
    goodBtn,
    complaintDialog,
    copyrightDialog,
    Avatar,
    CommentList,
    followBtn,
    rewardDialog,
    paidReadDialog,
    changeCardBtn
  },
  watch: {
    $route: function() {
      this.$router.go(0);
    }
  },
  data() {
    return {
      Id: 0,
      userId: 0,
      detail: {
        Id: 0,
        Title: "",
        Avatar: "",
        FeatureProduct: []
      },
      relatedList: [],
      isMyArticle: false,
      userInfo: {
        FollowStatus: 1,
        Id: 0,
        NickName: "",
        TrueName: "",
        Avatar: "",
        MobilePhone: "",
        Email: "",
        Introduction: "",
        Status: 1,
        PublishQuantity: 0,
        FollowQuantity: 0,
        FollowedQuantity: 0,
        Type: 1,
        GoodQuantity: 0
      },
      showComplain: false,
      showCopyright: false,
      loading: false,
      notShowChangeCardDialog: false,
      ShowChangeCardDialogKey: "notShowChangeCardDialog",
      showChangCard: false,
      showShare: false,
      shareOpts: null,
      isError: false,
      isNetWorkError: false,
      CoverImage: "",
      PaymentTotal: 0,
      PaymentList: []
    };
  },
  created() {
    this.init();
  },
  destroyed() {
    this.setDomTitle("Talk 工控");
    EventBus.clearAll();
  },
  methods: {
    init() {
      let _id = this.$route.query.id + "";
      if (_id.indexOf("-")) {
        this.Id = _id.split("-")[0];
      } else {
        this.Id = _id;
      }

      payServices.handleBack(this.$route.query);
      this.userId = this.$mdUtils.getUserInfo("Id") || undefined;
      EventBus.setGoodFunc(this.handleBusGetGoodStutas);
      this.getDetailById();
    },
    handleBack() {
      let backUrl = this.$route.query.backUrl;
      if (backUrl) {
        this.$router.push({ name: backUrl });
      } else {
        this.goBack();
      }
    },
    listenClickContentImg() {
      let contEl = document.getElementById("articleDetail");

      contEl.addEventListener("click", e => {
        if (e.target.localName === "img") {
          let src = e.target.src || "";
          ImagePreview([src]);
        }
      });
    },
    setDomTitle(title) {
      document.title = title;
    },
    getDetailById() {
      let userId = this.userId;
      this.loading = true;
      this.$api(
        Cms.GetArticleDetail,
        { Id: this.Id, UserId: userId },
        false,
        false
      )
        .then(res => {
          res.Content = this.$mdUtils.adWaterMark(res.Content)
          res.TrialContent = this.$mdUtils.adWaterMark(res.TrialContent)

          this.detail = res;
          this.isMyArticle = this.detail.UserId == this.userId;
          this.CoverImage =
            this.detail.CoverImage || this.$consts.NULL_COVER_IMAGE_URL;
          this.loading = false;
          return this.detail;
        })
        .then(detail => {
          return Promise.all([
            this.getRelatedList(detail),
            this.getUserInfo(detail),
            this.getPaymentList()
          ]);
        })
        .then(() => {
          this.handleShare();
          this.setDomTitle(this.detail.Title);
          this.loading = false;
          this.$nextTick(() => {
            this.handleGoodSuccess(this.detail.IsGood);
            this.listenClickContentImg();
          });
        })
        .catch(err => {
          this.loading = false;
          if (err.message !== 'Network Error') {
            this.isError = true;
          } else {
            this.isNetWorkError = true;
          }
          
          console.log("error:", err);
        });
    },
    getRelatedList(detail) {
      return this.$api(Cms.Search, {
        ExcludeIds: [this.Id],
        Terms: detail.Title,
        Tags: detail.Tags,
        PageSize: 3
      }).then(res => {
        this.relatedList = res.List;
      });
    },
    getUserInfo(detail) {
      return this.$api(Cms.UserGetHomePage, {
        Id: detail.UserId
      }).then(res => {
        this.userInfo = res;
      });
    },
    getPaymentList() {
      return this.$api(Cms.QueryPaymentByArticleId, {
        ArticleId: this.Id
      },false,false).then(res => {
        this.PaymentTotal = res.TotalRecord;
        this.PaymentList = res.List;
      });
    },
    handleFollowSuccess() {
      this.getUserInfo(this.detail);
    },
    handleBusGetGoodStutas(val) {
      this.detail.IsGood = val;
    },
    handleGoodSuccess(val) {
      EventBus.chooseGoodFunc(val);
    },
    backTop() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    showRewardDialog() {
      this.$refs.rewardDialog.init(this.userInfo, this.Id, this.detail.Title);
    },
    goPersonal() {
      this.$router.push({
        name: "personal",
        params: { id: this.userInfo.Id }
      });
    },
    gotoSearch(tag) {
      this.$router.push(`/search?value=${tag}`);
    },
    showPaidDialog() {
      this.$refs.paidReadDialog.init(
        this.userInfo,
        this.Id,
        this.detail.Title,
        this.detail.Price
      );
    },
    handlePaidReadSuccess() {
      this.$router.go(0);
    },
    rewardSuccess() {
      this.getPaymentList()
    },
    handleShare() {
      let opts = {
        img_url: this.detail.CoverImage || this.$consts.SHARE_IMAGE_URL,
        img_width: "200",
        img_height: "200",
        link:
          "http://m.talkgk.com/detail?id=" +
          this.detail.Id +
          "&?userid=" +
          this.userId,
        desc: this.$consts.SHARE_DESC,
        title: this.detail.Title,
        ArticleId: this.Id
      };
      shareServices.getBack(this, opts);
    },
    handleChangeCard() {}
  }
};
</script>
<style lang="scss">
.article-detail--page {
  .change-btn {
    overflow: hidden;
    .van-button {
      border: 0;
      height: 40px;
      width: 100%;
    }
  }
}
</style>


<style lang='scss' scoped>
.article-detail--page {
  .title {
    font-weight: bold;
    font-size: $font-size-big-more;
    color: $text-main;
  }
  .zhanwei {
    padding-top: 50px;
  }
  .copyright-icon {
    width: 80px;
    height: 24px;
    line-height: 24px;
    background: rgba(249, 249, 249, 1);
    border-radius: 100px;
    text-align: center;
    font-size: $font-size-small;
  }
  .md-card {
    padding: 0 12px;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.16);
    border-radius: 10px;
  }
  .line {
    width: 100%;
    height: 5px;
    background: $gray;
  }
  .feature-good {
    margin-bottom: 23px;
    .md-card {
      padding: 0 20px;
    }
  }
  .author-bottom {
    padding: 10px 0;
  }

  .detail-content {
    overflow: scroll;
    * {
      line-height: 24px;
      font-size: 14px;
      color: #2b323f;
    }
  }
  .more-info {
    margin-top: 30px;
    padding-bottom: 22px;
    border-bottom: 1px solid $gray;
  }
  .change-box {
    position: relative;
    top: 3px;
    display: flex;
    justify-content: space-around;
    padding-bottom: 22px;
  }
  .change-btn {
    height: 40px;
    line-height: 40px;
    width: 130px;
    text-align: center;
    border: 1px solid $border-color;
    border-radius: 5px;
    font-size: 16px;
    color: $gray-deep-more;
  }
  .tag-box {
    margin-top: 13px;
  }

  .author-block {
    margin-bottom: 17px;
    .avatar {
      width: 46px;
      height: 46px;
      margin-right: 12px;
      border-radius: 50%;
      border: 1px solid $gray;
    }
    .author-name {
      display: flex;
      margin: 0;
      font-weight: normal;
      color: $text-main;
      font-size: 0;
      .name {
        max-width: 140px;
        margin-right: 10px;
        overflow: hidden;
        text-overflow: ellipsis;
        line-height: 22px;
        white-space: nowrap;
        font-size: $font-size-big;
      }
      .iconfont {
        color: auto;
        font-size: $font-size-small;
      }
      .enterprise-icon {
        position: relative;
        top: 4px;
        padding: 0 8px;
        height: 18px;
        line-height: 18px;
        background: $orange;
        border-radius: 3px;
        font-size: $font-size-small;
        color: #fff;
      }
    }

    .author-msg {
      font-size: $font-size-small;
      padding-right: 10px;
      max-width: 180px;
    }

    .follow {
      display: flex;
      flex-direction: row;
      align-items: center;
    }
  }
  .trial-msg {
    text-align: center;
    font-size: $font-size-small;
    font-weight: bold;
  }
  .comment-box {
    margin-top: 15px;
  }

  .video-box {
    width: 100%;

    video {
      width: inherit;
    }
  }
  .reward-box {
    .reward-btn {
      padding: 20px 10px;
    }
  }
  .payment-title {
    position: relative;
    font-size: 16px;
    text-align: center;
    margin-bottom: 16px;
    margin-top: 16px;
    & span {
      position: relative;
    }

    & span::before,
    & span::after {
      content: "";
      display: block;
      position: absolute;
      top: 10px;
      width: 30px;
      padding: 1px;
      border-bottom: 1px solid $border-color;
    }
    & span::before {
      left: -40px;
    }
    & span::after {
      right: -40px;
    }
  }
  .payment-avatar {
    width: 56px;
    height: 56px;
    background: $lighter;
    border-radius: 50%;
    margin-right: 11px;
    margin-bottom: 11px;
  }
  .payment-list {
    width: 270px;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
  }
  .payment-more-icon {
    display: block;
    font-size: 24px;
    color: $gray-deep;
    text-align: center;
    line-height: 60px;
    box-shadow: 0px 0.8vw 1.6vw rgba(0, 0, 0, 0.16);
  }
  .loading-img {
    text-align: center;
    padding: 100px 0;
  }
}
.article-shadow {
  width: 100%;
  padding-bottom: 100px;
  position: absolute;
  bottom: 0;
  left: 0;
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    from(rgba(255, 255, 255, 0)),
    color-stop(70%, #fff)
  );
  background-image: linear-gradient(
    -180deg,
    rgba(255, 255, 255, 0) 0%,
    #fff 70%
  );
  text-align: center;

  .article-shadow-icon1,
  .article-shadow-icon2 {
    position: absolute;
    left: 50%;
    transform: translate(0, -50%);
    font-size: 24px;
  }
  .article-shadow-icon1 {
    color: $gray-shallow;
    bottom: -4px;
  }
  .article-shadow-icon2 {
    color: $gray-deep;
    bottom: -14px;
  }
  .author-icon {
    width: 34px;
    height: 24px;
  }
}
.content-empty {
  .empty-img {
    display: block;
    margin: 30px auto 10px;
    width: 60%;
  }
  .empty-msg {
    font-size: $font-size-normal;
    text-align: center;
  }
  .empty-icon {
    padding-top: 86px;
    padding-bottom: 20px;
    .iconfont {
      display: block;
      margin: 0 auto;
      font-size: 78px;
      text-align: center;
    }
  }
}
.network-error {
  .empty-msg,.iconfont {
    color: $text-main;
  }
  .empty-msg {
    font-weight: bold;
  }
}
</style>